import React, { useEffect, useState, useMemo } from 'react';
import TabGroup from '@paycor/design-system/tabs';
import HRIcon from './images/HRIcon.png';
import LegalEntityIcon from './images/LegalEntityIcon.png';
import OnboardingIcon from './images/OnboardingIcon.png';
import payrollIcon from './images/payrollIcon.png';
import RecrutingIcon from './images/RecrutingIcon.png';
import ReportingIcon from './images/ReportingIcon.png';
import TimeAndAttendanceIcon from './images/TimeAndAttendanceIcon.png';
import './apiExplorerTabList.scss';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ApiExplorerTabList = ({ selectedVersion }) => {

    const [selectedTag, setSelectedTag] = useState('All');
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedTag = queryParams.get('tag');
    const selectedTagFromUrl = encodedTag ? decodeURIComponent(encodedTag) : 'All';

    useEffect(() => {
        if (selectedTagFromUrl) {
            setSelectedTag(selectedTagFromUrl);
        } else {
            setSelectedTag('All');
        }
    }, [location]);


    const availableTags = useMemo(() => {
        return [
                {
                    tag: 'Legal Entity',
                    icon: LegalEntityIcon
                },
                {
                    tag: 'HR',
                    icon: HRIcon
                },
                {
                    tag: 'Payroll',
                    icon: payrollIcon
                },
                {
                    tag: 'Time & Attendance',
                    icon: TimeAndAttendanceIcon
                },
                {
                    tag: 'Onboarding',
                    icon: OnboardingIcon
                },
                
                {
                    tag: 'Recruiting',
                    icon: RecrutingIcon
                },
                {
                    tag: 'Reporting',
                    icon: ReportingIcon
                },           
                {
                    tag: 'All',
                    icon: HRIcon
                }
            ]
    }, [selectedVersion]);

    const onTabClick = (tag) => {
        const encodedTag = encodeURIComponent(tag);
        const params = new URLSearchParams(location.search);
        if (tag === 'All') {
            params.delete('tag');
        } else {
            params.set('tag', encodeURIComponent(tag));
        }
        history.push({ pathname: location.pathname, search: params.toString() });
    }


    return <div className="custom-tabs">
        <TabGroup key={selectedTag}>
            {availableTags.map((tag) => (
                <TabGroup.Tab
                    id={tag.tag}
                    title={
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                            <img src={tag.icon} />
                            <span>{tag.tag}</span>
                        </span>
                    }
                    key={tag.tag}
                    isActive={selectedTag === tag.tag}
                    onClick={() => onTabClick(tag.tag)}

                />
            ))}
        </TabGroup>
    </div>

}

export default ApiExplorerTabList;